<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { sanitizeUrl } from '@braintree/sanitize-url';
import { Controller, Navigation, Scrollbar } from 'swiper/modules';
import axios from 'axios';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';

export default {
    components: {
        Swiper,
        SwiperSlide,
    },
    setup() {
        return {
            modules: [Navigation, Scrollbar, Controller],
        };
    },
    methods: {
        sanitize(url) {
            return sanitizeUrl(url);
        },
        getFeaturedProperties() {
            axios.get('/properties/featured').then((response) => {
                this.$data.featured_properties = response.data.featured;
                 this.$nextTick(() => {
                    // After DOM update
                    this.lazyLoadImages();
                });
            });
        },
        lazyLoadImages() {
            this.imageRefs.forEach((img, i) => {
                const realSrc = img.dataset.src;
                const tempImg = new Image();
                tempImg.onload = () => {
                    img.src = realSrc;
                    this.spinnerRefs[i]?.classList.add('hide-spinner');
                };
                tempImg.onerror = () => {
                    // Optionally handle image loading error
                    this.spinnerRefs[i]?.classList.add('hide-spinner');
                };
                tempImg.src = realSrc;
            });
        },
    },
    mounted() {
        this.getFeaturedProperties();
    },
    data() {
        return {
            imageRefs: [],
            spinnerRefs: [],
            featured_properties: [],
            breakpoints: {
                1: {
                    slidesPerView: 1.2,
                    spaceBetween: 30,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
                1440: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                },
            },
            navButtons: {
                prevEl: '.prev-btn',
                nextEl: '.next-btn',
            },
        };
    },
};
</script>
<template>
    <div
        class="tw-w-full tw-border-0 tw-p-0 tw-m-0 tw-relative tw-h-[584px] featured-properties"
    >
        <div
            class="tw-absolute tw-left-0 tw-h-[404px] tw-w-[80px] tw-text-[32px] tw-pr-7 tw-bg-darkGreen tw-text-center tw-text-white"
            style="writing-mode: tb-rl; transform: rotate(-180deg)"
        >
            FEATURED PROPERTIES
        </div>
        <div class="">
            <div
                class="tw-relative tw-ml-[100px] xl:tw-ml-[auto] xl:tw-mr-[0px] xl:tw-pr-[4%] xl:tw-w-[85%]"
            >
                <swiper
                    :scrollbar="{
                        hide: false,
                    }"
                    :navigation="navButtons"
                    :modules="modules"
                    :centeredSlides="false"
                    :speed="1500"
                    :step="1"
                    :slidesPerView="1"
                    :slides-per-group="1"
                    :breakpoints="breakpoints"
                    class="featured-properties__swiper"
                >
                    <swiper-slide v-for="(featured, index) in featured_properties">
                        <div class="lazyload image-wrapper tw-relative tw-h-[540px]">
                            <a
                                :href="this.sanitize(featured.url)"
                                class="tw-no-underline"
                            >
                                <figure
                                    class="tw-mb-0 megamenu__property-gradient tw-h-full"
                                >
                                    <picture>
                                        <img
                                            :data-src="featured.featured_image"
                                            :alt="`${featured.name} thumbnail`"
                                            :ref="el => imageRefs[index] = el"
                                            width=""
                                            height=""
                                            class="swiper-lazy swiper-image tw-w-full tw-h-full tw-object-cover"
                                            loading="lazy"
                                        />
                                    </picture>
                                </figure>
                                <div class="manual-spinner" :ref="el => spinnerRefs[index] = el"></div>
                                <div
                                    class="tw-absolute tw-bottom-4 tw-left-0 tw-w-full tw-z-10"
                                >
                                    <h3
                                        class="tw-text-xl tw-font-bold tw-text-white tw-mb-0 text-no-underline tw-mx-4"
                                    >
                                        {{ featured.name }}
                                    </h3>
                                    <p
                                        class="tw-font-medium tw-text-midGreen tw-uppercase tw-mx-4 tw-tracking-widest tw-text-xs"
                                    >
                                        {{ featured.estate.name }}
                                    </p>
                                    <div v-if="featured.price !== null">
                                        <div
                                            v-if="
                                                featured.price.is_hidden_prize
                                            "
                                        >
                                            <p
                                                class="tw-inline-block tw-h-[42px] mb-0px"
                                            ></p>
                                        </div>
                                        <div v-else>
                                            <p
                                                v-if="featured.price !== null"
                                                class="tw-bg-white tw-inline-block tw-p-2 tw-font-regular tw-text-darkGreen tw-border-l-0 tw-border-y tw-border-r tw-border-solid tw-border-[#064333] tw-max-w-80pct tw-text-xs"
                                            >
                                                Starts at
                                                <span
                                                    class="tw-font-extrabold tw-text-base"
                                                    >PHP
                                                    {{
                                                        featured.price.price_min
                                                    }}</span
                                                >
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </swiper-slide>
                </swiper>
                <div
                    class="tw-absolute tw-bottom-[55px] tw-left-[-80px] tw-z-10"
                >
                    <div class="tw-flex tw-flex-row tw-space-x-1">
                        <button
                            class="prev-btn tw-bg-transparent tw-border-accentGreen tw-text-accentGreen tw-w-[32px] tw-h-[32px]"
                            style="border: 2px solid"
                        >
                            &lt;
                        </button>
                        <button
                            class="next-btn tw-bg-transparent tw-border-accentGreen tw-text-accentGreen tw-w-[32px] tw-h-[32px]"
                            style="border: 2px solid"
                        >
                            >
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
.rotated {
    writing-mode: tb-rl;
    transform: rotate(-180deg);
}
</style>
